import React from "react";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="returns-page">
      <div className="container">
        <h1>Returns & Exchanges</h1>
        <div className="content-section">
          <p className="intro">
            We hope you love your purchase, but if you need to make a return,
            we're here to help.
          </p>

          <div className="policy-group">
            <h3>Returns</h3>
            <p>
              Full-priced items can be returned within{" "}
              <strong>14 days of purchase</strong>, provided they are unused, in
              their original packaging and have all tags attached.
            </p>
            <p>
              You can choose a <strong>refund, exchange or store credit</strong>
              .
            </p>
            <p>
              Customers are responsible for return postage unless the item is
              damaged or faulty.
            </p>
          </div>

          <div className="policy-group">
            <h3>What Can't Be Returned?</h3>
            <p>
              Change-of-mind returns are not available on{" "}
              <strong>final-sale items</strong>.
            </p>
            <p>
              For hygiene reasons, <strong>opened body care and fragrance products</strong>{" "}
              cannot be returned.
            </p>
          </div>

          <div className="policy-group">
            <h3>Online Orders</h3>
            <p>
              Eligible online orders can be returned within 14 days where the
              item meets the conditions above. Contact us before sending an item.
            </p>
          </div>

          <div className="policy-group">
            <h3>Damaged or Faulty Items</h3>
            <p>
              If your item arrives damaged or faulty, please contact us so we
              can help.
            </p>
          </div>

          <div className="policy-group start-return">
            <h3>Start a Return</h3>
            <p>
              Email{" "}
              <a href="mailto:import@cewillowmarket.life">
                import@cewillowmarket.life
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Returns;
